import styles from "./VerifyShippingAddressBanner.module.scss";
import { useIntl } from "react-intl";
import clsx from "clsx";
import MiscellaneousWarning from "common/icons/MiscellaneousWarning.tsx";
import MiscellaneousXMedium from "common/icons/MiscellaneousXMedium.tsx";
import BaseLinkOrButton from "common/core-ui/BaseLinkOrButton";
import { useLayoutData } from "../layout/myCoursesLayoutLoader";
import useTermOptDeadline from "./useTermOptDeadline";
import { useCoursesLoaderData } from "./coursesLoader";
import useUserPreference from "routes/home/actions/user/useUserPreference";
import { UserPreferenceKey } from "common/api/decimal/methods/user";
import { SingleSpaceLiteral } from "common/core-ui/SingleSpaceLiteral";
import BannerContainer from "./common/BannerContainer";

export default function VerifyShippingAddressBanner() {
  const intl = useIntl();
  const updateShippingLink =
    useLayoutData().config.equitable_access.akademos.updateShippingLink;
  const { optWindowOpen } = useTermOptDeadline();
  const { allMaterials, currentTerm } = useCoursesLoaderData();
  const { courses } = useCoursesLoaderData();
  const learnerWithPrintMaterials = allMaterials
    .filter(({ materialFormat }) => materialFormat === "print")
    .some(
      ({ courseId }) =>
        courses.find((course) => course.id === courseId)?.userRole === "learner"
    );

  const [dismissExpiredOn, setExpiredOn] = useUserPreference<string>(
    UserPreferenceKey.MyCoursesVerifyShippingAddressExpiredOn
  );
  const userDismissed = dismissExpiredOn
    ? new Date(dismissExpiredOn) >= new Date()
    : false;

  if (
    userDismissed ||
    !currentTerm ||
    !updateShippingLink ||
    !optWindowOpen ||
    !learnerWithPrintMaterials
  ) {
    return null;
  }

  return (
    <div className={styles.container} role="alert" aria-live="polite">
      <BannerContainer
        className={styles.container}
        icon={<MiscellaneousWarning />}
      >
        <div className={styles.content}>
          <div className={styles.title}>
            {intl.formatMessage({
              defaultMessage: "Check Your Shipping Address",
            })}
          </div>
          <div>
            <span>
              {intl.formatMessage({
                defaultMessage:
                  "Make sure your print course materials will be delivered to the correct address.",
              })}
            </span>
            <SingleSpaceLiteral />
            <span>
              <BaseLinkOrButton
                className="vst-link"
                href={updateShippingLink}
                onClick={() => setExpiredOn(currentTerm.endOn)}
              >
                {intl.formatMessage({
                  defaultMessage: "View Shipping Address",
                })}
              </BaseLinkOrButton>
            </span>
          </div>
        </div>
        <div className={styles.close}>
          <button
            aria-label={intl.formatMessage({ defaultMessage: "Close" })}
            data-tooltip-content={intl.formatMessage({
              defaultMessage: "Close",
            })}
            onClick={() => setExpiredOn(currentTerm.endOn)}
            className={clsx(
              "vst-icon-button-circle",
              "vst-icon-button-size-small",
              "vst-icon-button-variant-black"
            )}
          >
            <MiscellaneousXMedium />
          </button>
        </div>
      </BannerContainer>
    </div>
  );
}
